import React from 'react';
import bem from 'utils/bem';
import { Info } from 'components/Info';
import Text from 'components/Text';
import { LinkButton } from 'components/Button';
import { whatsAppContacts } from 'components/AddressAndPhones';
import './index.sass';

const { block, el } = bem('foreign-card-widget');

export const ForeignCardWidget = () => {
    return <Info className={block()}>
        <div className={el('content')}>
            <Text>Если у вас карта иностранного банка, вы можете оплатить через специальный сервис</Text>
            <LinkButton className={el('button')} mod='transparent-gold' Tag='a' href={whatsAppContacts.link} target={'_blank'}>Перейти к оплате</LinkButton>
        </div>
    </Info>
}
